module.exports = __webpack_public_path__ + "img/fiber-remote-payment.aabcd282.png";